/* eslint-disable lines-between-class-members */
/* eslint-disable no-undef */
/**
 * Custom info box overlay builder
 */

import { getStoreHours, openStoreOnMap, refineStoreName } from './helpers'

export default {

  popUp: null,

  build(position, content) {
    class Popup extends google.maps.OverlayView {
      position
      containerDiv
      contentTitle
      contentStreet
      contentAddress
      contentPhoneNumber
      contentDistance
      contentOpen
      contentOpenIndicator
      contentButtons
      contentDirectionsButton

      constructor() {
        super()
        this.position = position
        content.classList.add('popup-bubble')

        // This zero-height div is positioned at the bottom of the bubble.
        const bubbleAnchor = document.createElement('div')

        bubbleAnchor.classList.add('popup-bubble-anchor')
        bubbleAnchor.appendChild(content)
        // This zero-height div is positioned at the bottom of the tip.
        this.containerDiv = document.createElement('div')
        this.containerDiv.classList.add('popup-container')
        this.containerDiv.appendChild(bubbleAnchor)
        // Optionally stop clicks, etc., from bubbling up to the map.

        this.setElementSelectors()

        Popup.preventMapHitsAndGesturesFrom(this.containerDiv)
      }

      /**
       * Set element selectors
       */
      setElementSelectors() {
        this.contentTitle = this.containerDiv.querySelector('.uberall-locator-info-box__title')
        this.contentAddress = this.containerDiv.querySelector('.uberall-locator-info-box__address')
        this.contentPhoneNumber = this.containerDiv.querySelector('.uberall-locator-info-box__pn')
        this.contentDistance = this.containerDiv.querySelector('.uberall-locator-info-box__distance')
        this.contentOpen = this.containerDiv.querySelector('.uberall-locator-info-box__hours-label')
        this.contentButtons = this.containerDiv.querySelector('.uberall-locator-info-box__buttons-wrapper')
        this.contentOpenIndicator = this.containerDiv.querySelector('.uberall-locator-info-box__is-open')
        this.contentStreet = this.containerDiv.querySelector('.uberall-locator-info-box__street')
        this.contentDirectionsButton = this.containerDiv.querySelector('.uberall-locator-info-box__get-directions')
      }

      /** Called when the popup is added to the map. */
      onAdd() {
        this.getPanes().floatPane.appendChild(this.containerDiv)
      }

      /** Called when the popup is removed from the map. */
      onRemove() {
        if (this.containerDiv.parentElement) {
          this.containerDiv.parentElement.removeChild(this.containerDiv)
        }
      }

      /** Called each frame when the popup needs to draw itself. */
      draw() {
        const divPosition = this.getProjection().fromLatLngToDivPixel(
          this.position,
        )
        // Hide the popup when it is far out of view.
        const display =
          Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
            ? 'block'
            : 'none'

        if (display === 'block') {
          this.containerDiv.style.left = `${divPosition.x}px`
          this.containerDiv.style.top = `${divPosition.y}px`
        }

        if (this.containerDiv.style.display !== display) {
          this.containerDiv.style.display = display
        }
      }
    }

    this.popUp = new Popup()
  },

  /**
   * Remove info box from map
   */
  removeBox() {
    this.popUp.setMap(null)
  },

  /**
   * Add info box to map
   * @param {Object} map
   */
  addBox(map) {
    this.popUp.setMap(map)
  },

  /**
   * Set new position for info box
   * @param {Object} position
   */
  setNewPosition(position) {
    this.popUp.position = position
  },

  /**
   * Update info box data with data received
   * @param {*} param0
   */
  updateData({ title, street, address, phone, distance, openHours, openNow, nextOpen }) {
    this.addTitle(title)
    this.addStreet(street)
    this.addAddress(address)
    this.addPhoneNumber(phone)
    this.addDistance(distance)
    this.addHours(openHours, nextOpen, openNow)
    this.setOpenIndicator(openNow)
    this.setClickOnGetDirections(this.popUp.position, title)
  },

  /**
   * Set new title of info box
   * @param {*} title
   */
  addTitle(title) {
    if (!title) {
      return
    }

    this.popUp.contentTitle.textContent = refineStoreName(title)
  },

  /**
   * Add store street data
   */
  addStreet(street) {
    if (!street) {
      return
    }

    this.popUp.contentStreet.textContent = street
  },

  /**
   * Set new address in info box
   * @param {String} address
   * @returns
   */
  addAddress(address) {
    if (!address) {
      return
    }

    this.popUp.contentAddress.textContent = `${address.city}, ${address.province} ${address.zip}`
  },

  /**
   * Set new phone number in info box
   * @param {String} phoneNumber
   * @returns
   */
  addPhoneNumber(phoneNumber) {
    if (!phoneNumber) {
      return
    }

    this.popUp.contentPhoneNumber.setAttribute('href', `tel: ${phoneNumber}`)
    this.popUp.contentPhoneNumber.textContent = phoneNumber
  },

  /**
   * Set new distance in info box
   * @param {String} phoneNumber
   * @returns
   */
  addDistance(distance) {
    if (!distance) {
      return
    }

    this.popUp.contentDistance.textContent = cnvs.strings.store_locator.distance_from_position.replace('{{#}}', distance)
  },

  /**
     * Set new distance in info box
     * @param {String} phoneNumber
     * @returns
     */
  addHours(hours, nextOpen, openNow) {
    if (!hours) {
      return
    }

    this.popUp.contentOpen.textContent = getStoreHours({
      openNow,
      nextOpen,
      openingHours: hours,
    })
  },

  /**
   * Show open indicator
   */
  setOpenIndicator(openNow) {
    if (!openNow) {
      this.popUp.contentOpenIndicator.classList.remove('is-open')

      return
    }

    this.popUp.contentOpenIndicator.classList.add('is-open')
  },

  /**
   * Set click on Get Direction button
   * @param {Object} storeLocation
   * @param {String} storeName
   */
  setClickOnGetDirections(storeLocation, storeName) {
    this.popUp.contentDirectionsButton.addEventListener('click', () => {
      openStoreOnMap(storeLocation, storeName)
    })
  },

}
